export const environment = {
  production: true,
  // extApi: 'http://localhost:4000/api/v2/',
  host: 'https://test-api.kaboodle.in/api/v2/',
  //host: 'http://localhost:3003/api/',
  // socket: 'https://staging.kaboodle.in:3004/',
  extApi: 'https://test-api.kaboodle.in/api/v2/',
  firebase: {
    apiKey: "AIzaSyCzkRMBWHUzg7yvYjcuhZbG3LWLUKH_2gc",
    authDomain: "kaboodle-14572.firebaseapp.com",
    projectId: "kaboodle-14572",
    storageBucket: "kaboodle-14572.firebasestorage.app",
    messagingSenderId: "38398634187",
    appId: "1:38398634187:web:0ea774aef48f62bd19934e"
  },

  CountryJson: [
    { name: 'India', dial_code: '+91', code: 'IN' },
    { name: 'Pakistan', dial_code: '+92', code: 'PK' }
  ],
  accessKeyId: "DO00KNC38JRDLCFJ7GVT",
  secretAccessKey: "RH1AQGjBkWhEo1jdqlh10eUtP/ED0zXz/mzCH1nG4j4",
  version: '1.1.2'
};